<template>
  <div style="line-height: 20px;padding: 0;">
    <div  style="display: flex; align-items: center">
      <p v-if="show.indexOf('name') > -1" @click="userInfoDialog">主人：<span style="color: #3a8ee6; cursor: pointer">{{row.name}}</span></p>
      <el-button v-if="showPayBtn" type="danger" round size="small" style="scale: 0.8" @click="openDialog(row.id)">充值</el-button>
    </div>
    <p v-if="show.indexOf('sex') > -1">性别：{{row.sex == 1?'男':row.sex == 2?'女':row.sex == 0?'未知':''}}</p>
    <p v-if="show.indexOf('phone') > -1">手机：{{row.phone}}</p>
    <p v-if="show.indexOf('shopName') > -1">门店：{{row.shopName}}</p>
    <p v-if="show.indexOf('uid') > -1">主人ID：{{row.uid}}</p>
  </div>
</template>

<script>
import Dialog from "@/assets/js/dialog";
import userInfoDialog from "@/components/User/userInfoDialog";
import SearchInfoDialog from "@/views/user/components/SearchInfoDialog";
import { getFormData } from "@/api/api";
import { getUserInfo } from "@/api/url";
export default {
  name: "UserInfo",
  components: {  },
  props: {
    row: {
      type: Object,
      default: () => {
        return {}
      }
    },
    userId: {
      type: String,
      default: ''
    },
    showList: {
      type: String,
      default: ''
    },
    showPayBtn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {

    }
  },
  methods: {
    userInfoDialog() {
      Dialog.open({
        title: '',
        component: userInfoDialog,
        data: {
          userId: this.userId,
          width: '720px',
        },
        confirm: () => {
          this.$emit('confirm')
        },
        close: () => {
          this.$emit('confirm')
        }
      })
    },

    openDialog() {
      getFormData(getUserInfo, {id: this.row.id}).then(data => {

        // this.userForm = data.data
        let walletDetail = {}
        Dialog.open({
          title: '',
          component: SearchInfoDialog,
          data: {
            userForm: data.data,
            walletDetail: walletDetail,
            width: '700px'
          },
          confirm: () => {
            this.$emit('confirm')
          }
        })

      })


    },

  },
  computed: {
    show() {
      return this.showList.split(',')
    }
  }
}
</script>

<style scoped>

</style>
